import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const FillRateVsEntregasBar = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);

  const allLabels = ['Retail', 'Servicios logísticos', 'Manufactura', 'Alimentos', 'Salud/Farmacéutica', 'Construcción', 'Automotriz'];

  const fillRateData2023 = {
    Retail: 96,
    'Servicios logísticos': 94,
    Manufactura: 91,
    Alimentos: 91,
    'Salud/Farmacéutica': 91,
    Construcción: 90,
    Automotriz: 81,
  };

  const entregasTiempoData2023 = {
    Retail: 91,
    'Servicios logísticos': 91,
    Manufactura: 94,
    Alimentos: 91,
    'Salud/Farmacéutica': 90,
    Construcción: 85,
    Automotriz: 93,
  };

  const fillRateData2024 = {
    Retail: 86,
    'Servicios logísticos': 95,
    Manufactura: 86,
    Alimentos: 97,
    'Salud/Farmacéutica': 100,
    Construcción: 96,
    Automotriz: 94,
  };

  const entregasTiempoData2024 = {
    Retail: 92,
    'Servicios logísticos': 92,
    Manufactura: 92,
    Alimentos: 92,
    'Salud/Farmacéutica': 91,
    Construcción: 86,
    Automotriz: 94,
  };

  const colorMap = {
    fillRate: '#1F3D58',
    entregasTiempo: '#A2AEBB',
    fillRate2024: '#476A8E',
    entregasTiempo2024: '#B0B0B0',
  };

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;
  const fillRateValues2023 = labels.map((label) => fillRateData2023[label]);
  const entregasTiempoValues2023 = labels.map((label) => entregasTiempoData2023[label]);
  const fillRateValues2024 = labels.map((label) => fillRateData2024[label]);
  const entregasTiempoValues2024 = labels.map((label) => entregasTiempoData2024[label]);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'Fill Rate (2022)',
        data: fillRateValues2023,
        backgroundColor: colorMap.fillRate,
      },
      {
        label: 'Fill Rate (2023)',
        data: fillRateValues2024,
        backgroundColor: colorMap.fillRate2024,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 20,
        bottom: 20,
        left: 10,
        right: 10,
      },
    },
    plugins: {
      legend: {
        position: 'top',
        labels: {
          boxWidth: 15,
          padding: 0,
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        color: '#fff',
        font: {
          weight: 'bold',
          size: 12,
        },
        formatter: (value) => `${Math.round(value)}`, // Formato como porcentaje
        anchor: 'end',
        align: 'end',
        offset: -25,
        clip: false,
      },
    },
    scales: {
      x: {
        title: {
          display: true, // Muestra el título del eje
          text: 'Porcentaje (%)', // Texto del eje X
          font: {
            size: 14,
            weight: '',
          },
          color: '#333',
        },
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 10,
        },
      },
      y: {
        title: {
          display: true, // Muestra el título del eje
          text: 'Industrias', // Texto del eje Y
          font: {
            size: 14,
            weight: '',
          },
          color: '#333',
        },
        categoryPercentage: 0.7,
        barPercentage: 0.5,
        ticks: {
          font: {
            size: 14,
          },
        },
      },
    },
  };

  const infoContent = {
    formulas: {
      fillRate: '(Total de piezas entregadas / Total de piezas solicitadas) × 100',
      //entregasTiempo: '(Órdenes entregadas dentro del plazo acordado / Total de órdenes) × 100',
    },
    description: 'Esta gráfica compara el Fill Rate (tasa de llenado) y las Entregas a Tiempo como porcentajes para distintas industrias durante los años 2022 y 2023. Ambos indicadores evalúan la eficiencia en la gestión de pedidos y entregas.',
    Analisis: 'Fill Rate de Compras en 2023 muestra una tendencia positiva en la mayoría de las industrias, destacando logros sobresalientes en Sector Salud/Farmacéuticas, Alimentos Construcción y Servicios logísticos. Estos resultados reflejan una mejora en la capacidad de abastecimiento, eficiencia en la cadena de suministro y cumplimiento con la demanda planificada, consolidando prácticas de compra más efectivas en diversas industrias ',
      
  };
  

  return (
    <div style={{ maxWidth: '1000px', height: '480px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
        <p><strong>Análisis:</strong> {infoContent.Analisis}</p>
          <p><strong>Fórmulas:</strong></p>
          <p>Fill Rate: {infoContent.formulas.fillRate}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
  
};

export default FillRateVsEntregasBar;
